module.exports = __webpack_public_path__ + "img/meh.b7a92f62.svg";